import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PORTAL_ADMIN_RESOURCES } from '../models/portal-resources';

@Component({
  selector: 'lib-portal-dashboard',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './portal-dashboard.component.html',
  styleUrl: './portal-dashboard.component.scss',
})
export class PortalDashboardComponent {
  readonly resources = PORTAL_ADMIN_RESOURCES;
}
